import utils from '@/core/utils'
import _ from 'lodash'

function createSearchResultQueryParams(searchQuery, entities, activeTab = 'items') {
  const pageSizeParams = _.reduce(entities, (acc, current, key) => {
    acc[key] = current.totalCount || 200
    return acc
  }, {})
  return utils.param({
    ...pageSizeParams,
    activeTab,
    query: searchQuery
  })
}

export { createSearchResultQueryParams }
